// extracted by mini-css-extract-plugin
export default {"container":"Course_container__7Bw7E"};